import _ from 'lodash';
import interact from 'interactjs';
import $ from 'jquery';

const dragMoveListener = function (event) {
	if(event.interaction._ending) { return; } // Don't know why we need this... but we do to not set the y to the initial value.
	//debugger;
	let target = event.target
	// keep the dragged position in the data-x/data-y attributes
	let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
	let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

	// translate the element
	target.style.webkitTransform =
	target.style.transform =
		'translate(' + x + 'px, ' + y + 'px)';

	// update the position attributes

	target.setAttribute('data-x', x);
	target.setAttribute('data-y', y);
};

const dragMoveListenerElements = function (event) {
	if(event.interaction._ending) { return; } // Don't know why we need this... but we do to not set the y to the initial value.
	//debugger;
	let target = event.target
	// keep the dragged position in the data-x/data-y attributes
	let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
	let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

	// translate the element
	target.style.webkitTransform =
	target.style.transform =
		'translate(' + x + 'px, ' + y + 'px)';

	// update the position attributes

	target.setAttribute('data-x', x);
	target.setAttribute('data-y', y);
};


const initLeftRailDragDrop = (experiment) => {
	interact('.draggable')
	.draggable({
		inertia: false,
		// keep the element within the area of it's parent
		restrict: {
			restriction: "parent",
			endOnly: true,
			elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
		},
		// enable autoScroll
		autoScroll: true,

		onstart: function(event){
			$('.temp-no-mouse').removeClass('temp-no-mouse');
			event.target.classList.add("is-dragging");
			event.target.classList.add("temp-no-mouse");
			event.target.nextElementSibling.classList.add("temp-no-mouse");
			event.target.previousElementSibling.classList.add("temp-no-mouse");
			document.querySelector('body').classList.add('body-dragging');
		},

		// call this function on every dragmove event
		onmove: dragMoveListener,
		// call this function on every dragend event
		onend: (event) => {
			$('.temp-no-mouse').removeClass('temp-no-mouse');
			event.target.classList.remove("is-dragging");
			event.target.style.transform = 'translate(0px, 0px)';
			event.target.setAttribute('data-x', 0);
			event.target.setAttribute('data-y', 0);
			document.querySelector('body').classList.remove('body-dragging');

			// TODO: Don't have duplicate keys
			let dragParent = event.target._parent;
			let dragScreen = event.target._screen;

			let dropParent = experiment.onScreenDropParams.parent;
			let dropScreen = experiment.onScreenDropParams.screen;

			// If there is not a dropParent, then nothing needs to be done.
			// dropParent is the parent array containing the dropArea that is curently selected.
			if(dropParent){
				_.pull(dragParent, dragScreen);
				// We always insert before the dropScreen.
				// If there is not a dropScreen, it means we are at the end of the array. We can just add it to the end.
				if(dropScreen){
					dropParent.splice(dropParent.indexOf(dropScreen), 0, dragScreen);
				}else{
					dropParent.push(dragScreen);
				}
			}

			experiment.forceUpdate();

			experiment.skipClick = true;
			_.delay(()=>{ experiment.skipClick = false; }, 100);
		}
	});
};








const initElementDragDrop = (experiment) => {
	interact('.draggable-element')
	.draggable({
		inertia: false,
		restrict: {
			restriction: "parent",
			endOnly: true,
			elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
		},

		autoScroll: true,

		allowFrom: '.drag-handle',

		onstart: function(event){
			$('.temp-no-mouse').removeClass('temp-no-mouse');
			event.target.classList.add("is-dragging");
			event.target.classList.add("temp-no-mouse");
			document.querySelector('body').classList.add('body-dragging');
		},

		// call this function on every dragmove event
		onmove: dragMoveListenerElements,
		// call this function on every dragend event
		onend: (event) => {
			$('.temp-no-mouse').removeClass('temp-no-mouse');
			event.target.classList.remove("is-dragging");

			let dx = parseFloat(event.target.getAttribute('data-x'))
			let dy = parseFloat(event.target.getAttribute('data-y'))

			experiment.selectedElements.forEach(element => {
				element.x = parseFloat(element.x) + dx;
				element.y = parseFloat(element.y) + dy;
			});

			event.target.style.transform = 'translate(0px, 0px)';
			event.target.setAttribute('data-x', 0);
			event.target.setAttribute('data-y', 0);
			document.querySelector('body').classList.remove('body-dragging');

			experiment.forceUpdate();
		}
	}).resizable({
		// resize from all edges and corners
		edges: { 
			right: '.resize-handle-right, .resize-handle-corner',
			bottom: '.resize-handle-bottom, .resize-handle-corner',
		},
	
		//allowFrom: '.resize-handle',

		// keep the edges inside the parent
		restrictEdges: {
			outer: 'parent',
			endOnly: true,
		},
	
		// minimum size
		restrictSize: {
			min: { width: 10, height: 10 },
		},
	
		inertia: false,

		onend: (event)=>{
			$('.temp-no-mouse').removeClass('temp-no-mouse');
			event.target.classList.remove("is-dragging");

			let dx = parseFloat(event.target.getAttribute('data-x'))
			let dy = parseFloat(event.target.getAttribute('data-y'))

			experiment.selectedElements.forEach(element => {
				element.x = parseFloat(element.x) + dx;
				element.y = parseFloat(element.y) + dy;
				element.width = event.interaction.resizeRects.previous.width;
				element.height = event.interaction.resizeRects.previous.height;
			});

			event.target.style.transform = 'translate(0px, 0px)';
			event.target.setAttribute('data-x', 0);
			event.target.setAttribute('data-y', 0);
			document.querySelector('body').classList.remove('body-dragging');
			experiment.forceUpdate();
		}
		})
		.on('resizemove', function (event) {
		if(event.interaction._ending) { return; } // Don't know why we need this... but we do to not set the y to the initial value.
		var target = event.target,
			x = (parseFloat(target.getAttribute('data-x')) || 0),
			y = (parseFloat(target.getAttribute('data-y')) || 0);
	
		// update the element's style
		target.style.width  = event.rect.width + 'px';
		target.style.height = event.rect.height + 'px';
	
		// translate when resizing from top or left edges
		x += event.deltaRect.left;
		y += event.deltaRect.top;
	
		target.style.webkitTransform = target.style.transform =
			'translate(' + x + 'px,' + y + 'px)';
	
		target.setAttribute('data-x', x);
		target.setAttribute('data-y', y);
		//target.textContent = Math.round(event.rect.width) + '\u00D7' + Math.round(event.rect.height);
		});;
};

export {
	initLeftRailDragDrop,
	initElementDragDrop,
}


// WEBPACK FOOTER //
// ./src/components/Builder/ExperimentDragDropHelper.js